import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabCultureHeaderApi } from '../api/labcultureheader.api';
import { switchMap, map } from 'rxjs/operators';

import { LabCultureHeaderData, LabCultureHeader } from '../../../interfaces/masters/labcultureheader' ;
@Injectable()
export class LabCultureHeaderService extends LabCultureHeaderData {

    constructor(private api: LabCultureHeaderApi) {
      super();
    }
  
  
    list(url: string): Observable<LabCultureHeader[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LabCultureHeader>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LabCultureHeader): Observable<LabCultureHeader[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:LabCultureHeader): Observable<LabCultureHeader> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  